import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfSectionLRIcons from '@elem/ui/ef-section-l-r-icons';
import EfSpec from '@elem/ui/ef-spec';
import EfTab, { EfTabItemProps } from '@elem/ui/ef-tab';
import EFCoffeeMaker from 'elem/ui-assets/icons/appliances/EFCoffeeMaker';
import EFElectricGrill from 'elem/ui-assets/icons/appliances/EFElectricGrill';
import EFFan from 'elem/ui-assets/icons/appliances/EFFan';
import EFLight from 'elem/ui-assets/icons/appliances/EFLight';
import EFPhone from 'elem/ui-assets/icons/appliances/EFPhone';
import EFRefrigerator from 'elem/ui-assets/icons/appliances/EFRefrigerator';
import EFTV from 'elem/ui-assets/icons/appliances/EFTV';
import EFWiFi from 'elem/ui-assets/icons/appliances/EFWiFi';
import { useRouter } from 'next/router';
import { useState } from 'react';
import styles from './index.module.scss';
import { useProductStore } from './../../../ProductProvider';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale } = useRouter();
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);
    const IS_NA_SITES = ['us', 'ca'].includes(locale);
    const { pageStatus } = useProductStore();

    const listTabH: EfTabItemProps[] = [
        {
            type: 'a1',
            title: t('L_item1_tab'),
        },
        {
            type: 'a2',
            title: t('L_item2_tab'),
        },
    ];
    const imgEUA2 = 'https://websiteoss.ecoflow.com/upload/image/1725264321930/5kw_eu.png';
    const imgUKA2 = 'https://websiteoss.ecoflow.com/upload/image/1725264322131/5kw_uk.png';
    const imgEUA1 = 'https://websiteoss.ecoflow.com/upload/image/1725268093600/vs_eu.png';
    const imgUKA1 = 'https://websiteoss.ecoflow.com/upload/image/1725268093771/vs_uk.png';
    const tabObj: any = {
        a1: {
            pc: (() => {
                const maps = {
                    jp: 'https://websiteoss.ecoflow.com/upload/image/1723608531628/2kWh%E7%BB%84%E5%90%88.png',
                    en: 'https://websiteoss.ecoflow.com/upload/image/1725264025077/d2vsd3.png',
                    uk: imgUKA1,
                    eu: imgEUA1,
                    de: imgEUA1,
                    fr: imgEUA1,
                    it: imgEUA1,
                    es: imgEUA1,
                };
                return maps[locale] || maps.en;
            })(),
            title: IS_EU_SITES ? t('L_item1_title') : IS_NA_SITES ? t('L_item1_tab') : t('L_item1_text'),
            desc: IS_EU_SITES ? t('L_item1_desc') : IS_NA_SITES ? t('L_item1_text') : '',
            list: [
                {
                    title: t('L_item1_app1'),
                    icon: <EFLight />,
                },
                {
                    title: t('L_item1_app2'),
                    icon: <EFPhone />,
                },
                {
                    title: t('L_item1_app3'),
                    icon: <EFFan />,
                },
                {
                    title: t('L_item1_app4'),
                    icon: <EFRefrigerator />,
                },
                {
                    title: t('L_item1_app5'),
                    icon: <EFTV />,
                },
                {
                    title: t('L_item1_app6'),
                    icon: <EFWiFi />,
                },
                {
                    title: t('L_item1_app7'),
                    icon: <EFElectricGrill />,
                },
                {
                    title: t('L_item1_app8'),
                    icon: <EFCoffeeMaker />,
                },
            ],
        },
        a2: {
            pc: (() => {
                const maps = {
                    jp: 'https://websiteoss.ecoflow.com/upload/image/1723608531641/5kWh%E7%BB%84%E5%90%88.png',
                    en: 'https://websiteoss.ecoflow.com/upload/image/1724662238989/a1.png',
                    uk: imgUKA2,
                    eu: imgEUA2,
                    de: imgEUA2,
                    fr: imgEUA2,
                    it: imgEUA2,
                    es: imgEUA2,
                };
                return maps[locale] || maps.en;
            })(),
            title: IS_EU_SITES ? t('L_item2_title') : IS_NA_SITES ? t('L_item2_tab') : t('L_item2_text'),
            desc: IS_EU_SITES ? t('L_item2_desc') : IS_NA_SITES ? t('L_item2_text') : '',
            list: [
                {
                    title: t('L_item2_app1'),
                    icon: <EFLight />,
                },
                {
                    title: t('L_item2_app2'),
                    icon: <EFPhone />,
                },
                {
                    title: t('L_item2_app3'),
                    icon: <EFFan />,
                },
                {
                    title: t('L_item2_app4'),
                    icon: <EFRefrigerator />,
                },
                {
                    title: t('L_item2_app5'),
                    icon: <EFTV />,
                },
                {
                    title: t('L_item2_app6'),
                    icon: <EFWiFi />,
                },
                {
                    title: t('L_item2_app7'),
                    icon: <EFElectricGrill />,
                },
                {
                    title: t('L_item2_app8'),
                    icon: <EFCoffeeMaker />,
                },
            ],
        },
    };
    // 选中的tab
    const [activeType, setActiveType] = useState('a1');
    const [activeItem, setActiveItem] = useState(tabObj[activeType]);
    // tab切换回调
    const activeTypeCallback = (item: EfTabItemProps) => {
        setActiveType(item.type);
        setActiveItem(tabObj[item.type] || tabObj['a1']);
    };
    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfSection
                label={t.rich(IS_EU_SITES && pageStatus === 'statusB' ? 'L_label2' : 'L_label', {
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                })}
                title={t.rich('L_title', {
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                })}
            />
            <EfSectionLRIcons pc={activeItem.pc} title={activeItem.title} desc={activeItem.desc} list={activeItem.list} />
            <EfTab list_name={t('L_title')} items={listTabH} activeType={activeType} onChange={activeTypeCallback} />
        </div>
    );
}
